import { Col, Row, Tabs } from "antd";
import { useEffect, useState } from "react";
import { ORG_TYPES } from "../../Common/Constants";
import { useRequiredAccess } from "../../../hooks/useRequiredAccess";
import Fleet from "./Fleet";
import Vehicle from "./Vehicle";

const BatteryPerformance = () => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const [selectedTab, setSelectedTab] = useState("vehicle");
  const checkAccess = useRequiredAccess(
    [],
    [ORG_TYPES.ADMINISTRATOR, ORG_TYPES.MANUFACTURER]
  );

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const items = [
    {
      key: "vehicle",
      label: "Vehicle",
      children: selectedTab === "vehicle" ? <Vehicle /> : null,
    },
    {
      key: "fleet",
      label: "Fleet",
      children: selectedTab === "fleet" ? <Fleet /> : null,
    },
  ];

  const showFleetTab = ["Admin", "Executive", "Fleet Manager"].includes(
    userDetails?.currentOrgRole
  );

  const onChangeTab = (key) => {
    setSelectedTab(key);
  };

  return (
    <Row gutter={16} data-testid="battery-performance">
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <Tabs
          activeKey={selectedTab}
          items={
            showFleetTab ? items : items.filter((item) => item.key !== "fleet")
          }
          onChange={onChangeTab}
        />
      </Col>
    </Row>
  );
};

export default BatteryPerformance;
